/**
 * @file List component to show application settings.
 * @author Tom Verschoore de la Houssaije
 */
import * as tslib_1 from "tslib";
import { TranslateService } from '@ngx-translate/core';
import { ListBase } from '../../base/list/list.base';
import { AlertsService } from '../../core/alerts.service';
import { DialogService } from '../../core/dialog.service';
import { EventsService } from '../../core/event.service';
import { LocalStorageService } from '../../core/local-storage.service';
import { OverlayService } from '../../core/overlay.service';
import { BackendSettingsService } from '../../backend-settings.service';
import { UserService } from '../../user.service';
import { Router } from '@angular/router';
import { ActionService } from '../../core/action.service';
/**
 * List component to show application settings.
 * @export../backend-settings.service
 * @class SettingsListComponent
 * @extends {ListBase}
 */
var SettingsListComponent = /** @class */ (function (_super) {
    tslib_1.__extends(SettingsListComponent, _super);
    /**
     * Creates an instance of SettingsListComponent.
     * @param {configurationsService} configurationsService
     * @param {BackendSettingsService} settingsService
     * @param {DialogService} dialogService
     * @param {AlertsService} alertsService
     * @param {TranslateService} translateService
     * @param {RouterService} routerService
     * @param {OverlayService} overlayService
     * @param {LocalStorageService} localStorageService
     * @memberOf SettingsListComponent
     */
    function SettingsListComponent(userService, settingsService, dialogService, alertsService, translateService, router, overlayService, localStorageService, eventsService, actionService) {
        return _super.call(this, userService, settingsService, dialogService, alertsService, translateService, router, overlayService, localStorageService, eventsService, actionService) || this;
    }
    /**
     * Sorting is not supported for settings
     * @param {FieldConfiguration} field Setting field
     * @returns {boolean} False
     * @memberOf SettingsListComponent
     */
    SettingsListComponent.prototype.isSortable = function (field) {
        return false;
    };
    return SettingsListComponent;
}(ListBase));
export { SettingsListComponent };
